import React from 'react'
import { InputContainer } from '../../../../../../common/components/form/form.module'
import { InputLabelContainer } from '../../../../../../common/components/form/label/containers/input-label.container'

export default function SettlementRequestsBasicInfoComponent({
  handleInnerFormChange,
  selectedSettlementRequest,
  onClose,
  handleFormSubmit
}: any) {

  return (
    <>
      <div className="flex justify-center items-center w-[600px]">
        <div className="w-full max-w-lg p-2 bg-white shadow-md rounded-md">
          <h1 className="text-xl font-bold mb-4 text-center">{selectedSettlementRequest?.Id ? "Edit Settlement Request" : "Add New Settlement Request"}</h1>
          <div className="flex flex-col gap-4">
            <InputContainer
              label="Order Id"
              name="OrderId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'OrderId',
                })
              }}
              type="text"
              value={selectedSettlementRequest?.OrderId}
            />
            <InputContainer
              label="Collector"
              name="CollectorAppId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path:'CollectorAppId',
                })
              }}
              type="text"
              value={selectedSettlementRequest?.CollectorAppId}
            />
            <InputContainer
              label="Receiver"
              name="ReceiverAppId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'ReceiverAppId',
                })
              }}
              type="text"
              value={selectedSettlementRequest?.ReceiverAppId}
            />
          
            <InputContainer

              label="Type"
              name="SettlementRequestTypeId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'SettlementRequestTypeId',

                })
              }}
              type="text"
              value={selectedSettlementRequest?.SettlementRequestTypeId}
            />
            <InputContainer

              label="Status"
              name="SettlementRequestStatusId"
              onValueChange={(event: any) => {
                handleInnerFormChange({
                  value: event.target.value,
                  path: 'SettlementRequestStatusId',

                })
              }}
              type="text"
              value={selectedSettlementRequest?.SettlementRequestStatusId}
            />
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onClose}
              type="button"
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
            >
              Close
            </button>
            <button
              className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3"
              onClick={handleFormSubmit}
              type="submit"
            >
              Save
            </button>
          </div>
        </div>
      </div>

    </>
  )
}